import { inject, observer } from 'mobx-react';
import { Regenerate, Copy, FeedBack } from '../OperateButton';
import { contentType } from '@/utils/Page/constant';
import { Display } from '@/components/Display/Display';
import { third_json_handler } from '@/utils/Page/constant';
import { useEffect, useState } from 'react';
const noFooterTypes = [contentType.multimodal_learning, contentType.multimodal];

// todo---此页面需要补充deerflow的逻辑

const MessageFooter = (props) => {
    const { item, side, inInanswer, len, index, deerFlowHook, store, reGenerate, isInVoiceCall, hideTTSActionsRef, feedBack, status, copy } = props;
    let { skillStore, voiceCallStore } = store;
    const { isNoFooterSkills } = skillStore;
    const { hideTTSActions } = voiceCallStore;
    const { content_type, role, recommend_course_result, handler } = item;
    const [showAction, setShowAction] = useState(false);

    const showActionInIntelligentQASKill = () => {
        if (item.handler === third_json_handler.intelligent_qa) {
            console.log(item, 'item');
            const { intelligent_qa_result = {} } = item || {};
            const { intelligent_qa_clarification = {} } = intelligent_qa_result || {};
            let isHasClari = intelligent_qa_clarification && Object.keys(intelligent_qa_clarification).length > 0;
            let selected_value = intelligent_qa_clarification?.selected_value || [];
            const isSubmit = selected_value?.length > 0;
            if (isHasClari && !isSubmit) {
                return false;
            }
        }
        return true;
    };
    useEffect(() => {
        let res = showActionInIntelligentQASKill();
        setShowAction(res);
    }, [item]);
    // if (index === len - 1) {
    //     console.log(inInanswer, 'statusstatusstatus');
    // }
    return (
        <>
            <Display
                show={
                    role !== 'local' && !noFooterTypes.includes(content_type) && !isNoFooterSkills() && !noFooterTypes.includes(handler) && showAction
                }
            >
                <Display show={status === 'complete'}>
                    <div
                        data-side={side}
                        data-answer={index === len - 1 && inInanswer ? 'true' : 'false'} // 只对最新消息应用inInanswer
                        className={`ai-action-wrap ${index === len - 1 ? 'last-msg' : 'previous-msg'}`}
                    >
                        {/* <Display show={side === 'mobile' ? (index === messages.length - 1 ? true : false) : true}> */}
                        <></>
                        <Display show={!recommend_course_result && hideTTSActions}>
                            <Copy
                                side={side}
                                className={`ai-copy-icon ${index !== len - 1 ? 'disabled' : ''}`}
                                onClick={(e) => {
                                    copy(item);
                                }}
                            ></Copy>

                            <Display show={skillStore?.skillAvailable}>
                                <Regenerate
                                    side={side}
                                    className={`ai-generate-icon ${index !== len - 1 ? 'disabled' : ''}`}
                                    onClick={() => {
                                        reGenerate(item);
                                    }}
                                    style={{
                                        display: item?.plugin_json?.voice_call && !isInVoiceCall ? 'none' : 'inline-block'
                                    }}
                                ></Regenerate>
                            </Display>
                        </Display>
                        <Display show={!recommend_course_result && hideTTSActions}>
                            <FeedBack
                                side={side}
                                className="ai-feed-back-icon"
                                onClick={() => {
                                    feedBack(item);
                                }}
                            ></FeedBack>
                        </Display>
                    </div>
                </Display>
            </Display>
        </>
    );
};
export default inject('store')(observer(MessageFooter));
